module.exports = __webpack_public_path__ + "static/img/ShakeShake.1919f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/ShakeShake.png
// module id = 8RmB
// module chunks = 1